import { useEffect, useRef, useState } from "react";

export function useFocusFlash(keys, focus, onHit) {
  const ref = useRef(null);
  const [flash, setFlash] = useState(false);
  const hit = !!focus && keys.includes(focus.key);
  useEffect(() => {
    if (!hit) { return undefined; }
    if (onHit) onHit();
    const go = () => ref.current?.scrollIntoView({ behavior: "smooth", block: window.innerWidth < 768 ? "start" : "center" });
    const a = setTimeout(() => { go(); setFlash(true); }, 150);
    const c = setTimeout(go, 800);
    const b = setTimeout(() => setFlash(false), 950);
    return () => { clearTimeout(a); clearTimeout(b); clearTimeout(c); };
  }, [hit, focus?.t]); // eslint-disable-line react-hooks/exhaustive-deps
  return [ref, flash];
}
